// extracted by mini-css-extract-plugin
export default {"page_wrapper":"Page_page_wrapper__C+ZTZ","title":"Page_title__8NjAW"};